import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IStateService } from 'angular-ui-router';


interface IPageAc0021 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    valeursEcran: any;
}
interface IAc0021Params {
    demcleint: string;
    aftcleint: string;
    employe: string;
    menuId: string;
    efface_criteres: boolean;
}

/* @ngInject */
export default function Ac0021Controller(
    Menu: IMenuClass,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    $stateParams: IAc0021Params,
    MenuItemForage: IMenuItemForageClass,
    MenuItemAction: IMenuItemActionClass,
    MenuItemEcran: IMenuItemEcranClass,
    $state: IStateService,
    ac0010Route: IRoute,
    ac2002Route: IRoute
) {
    const vm: IPageAc0021 = this;
    vm.valeursEcran = ecranDetails.valeurs;
    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false,
            reinitialiserOuvrirCriteres: true,
            criteresSuggeresVisibles: localStorage.getItem('forageFromMenu') === 'oui',
            edition: false,
            supprime: false
        },
        navigatePage: ac0010Route.NAME,
        navigateParams: (rowData: any) => (
            {
                id: rowData.doccleintref,
                refcleint: rowData.refcleint,
                caacleint: rowData.caacleint,
                intcleintreq: rowData.intcleintreq,
                fonction: 'BOUOUV'
            }
        ),
        actionsNouveaux: new Menu([
            new MenuItemEcran(
                '',
                ac2002Route.NAME,
                () => ({}),
                {
                    iconButton: false,
                    icon: 'add_circle',
                }
            )
        ]),
        actionsMoreLigne: new Menu([
            new MenuItemAction(
                'LBL_BTN_COPIE',
                'BOUCOP',
                () => ({}),
                {
                    icon: 'content_copy',
                    iconButton: true,//,,
                    successAction: (response) => {
                        $state.go(ac0010Route.NAME, {
                            id: response.doccleintnew,
                            menuId: $stateParams.menuId
                        });
                    },
                }

            )
        ]),

        criteresSuggeres: new Formulaire([
            new FormulaireItem('daccleint', { required: false }),
            new FormulaireItem("refcleintcri"),
            new FormulaireItem("peccleint", { required: false }),
            new FormulaireItem("sysboncmd"),
            new FormulaireItem("tydcleint", { required: false }),
            new FormulaireItem('etdcleint', { default: null, required: false }),
            new FormulaireItem("dacdatdeb"),
            new FormulaireItem("dacdatfin"),
            new FormulaireItem("intcleintreq", { required: false }),
            new FormulaireItem("intcleintdem", { required: false }),
            new FormulaireItem("usrcre", { required: false }),
            new FormulaireItem("cifcleint", { required: false }),
            new FormulaireItem("grpcleint", { required: false }),//unacleint-grpcleint
            new FormulaireItem("prucleintdeb", { required: false }),
            new FormulaireItem("prucleintfin", { required: false }),

        ], { criteresSuggeresAfficherLovsInactives: ['refcleintcri'] }),
        colonnesVisibles: [
            { nom: 'dacnumdoc', largeur: 120 },
            { nom: 'dacnumdocseq', largeur: 100 },
            { nom: 'sysboncmdtxt', largeur: 120 },
            { nom: 'dacseqave', largeur: 100 },
            { nom: 'dacsou', largeur: 150 },
            { nom: 'tydcod', largeur: 100 },
            { nom: 'dacdsc', largeur: 300 },
            { nom: 'refcod', largeur: 100 },
            { nom: 'refnom', largeur: 200 },
            { nom: 'refnomabr', largeur: 200 },
            { nom: 'etddsc', largeur: 300 },
            { nom: 'flgcou', largeur: 100 },
            { nom: 'flgnonrec', largeur: 100 },
            { nom: 'flgrecpar', largeur: 100 },
            { nom: 'flgfca', largeur: 100 },
            { nom: 'peccod', largeur: 100 },
            { nom: 'vaesysdevcod', largeur: 100 },
            { nom: 'dacmnt', largeur: 100 },
            { nom: 'dacrefint', largeur: 100 },
            { nom: 'caacod', largeur: 120 },
            { nom: 'caadsc', largeur: 300 },
            { nom: 'etcnumdoc', largeur: 120 },
            { nom: 'etcdsc', largeur: 300 },
            { nom: 'aponumdoc', largeur: 100 },
            { nom: 'intcodach', largeur: 100 },
            { nom: 'intnomach', largeur: 150 },
            { nom: 'intcoddem', largeur: 120 },
            { nom: 'intnomdem', largeur: 150 },
            { nom: 'intcodreq', largeur: 100 },
            { nom: 'intnomreq', largeur: 150 },
            { nom: 'vecdaccat', largeur: 100 },
            { nom: 'lipcod', largeur: 100 },
            { nom: 'flgerr_b2b', largeur: 100 },
            { nom: 'usrcod', largeur: 120 },
            { nom: 'motcod', largeur: 120 },
            { nom: 'motdsc', largeur: 150 },
            { nom: 'flgtran', largeur: 150 },
            { nom: 'flgimp', largeur: 150 },
            { nom: 'dacdat', largeur: 150 },
            { nom: 'dacdatbc', largeur: 150 },
            { nom: 'dacdatreq', largeur: 150 },
            { nom: 'dateofficiel', largeur: 150 },
            { nom: 'dacdatree', largeur: 150 },
            { nom: 'dacdatdeb', largeur: 150 },
            { nom: 'dacdatfin', largeur: 150 },
            { nom: 'sldeng', largeur: 150 },
            { nom: 'nibcod', largeur: 150 },
            { nom: 'nibnom', largeur: 300 }
        ],
        colonnesCachees: [
            'doccleintref', 'refcleint', 'caacleint', 'intcleintreq'
        ]
    };
}
